import { render, staticRenderFns } from "./GeneralSettingIndex.vue?vue&type=template&id=67a3ef02&"
import script from "./GeneralSettingIndex.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingIndex.vue?vue&type=style&index=0&id=67a3ef02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports